export enum BankAccountType {
    GETTING_SETTLEMENT_ACCOUNT = "GETTING_BANK_ACCOUNT",
    GETTING_SETTLEMENT_ACCOUNT_SUCCESS = "GETTING_SETTLEMENT_ACCOUNT_SUCCESS",
    GETTING_SETTLEMENT_ACCOUNT_FAILURE = "GETTING_SETTLEMENT_ACCOUNT_FAILURE"
}